import { NO_ELEMENT } from 'utils';
import { WrappedFieldMetaProps } from 'redux-form';
import styles from './styles.scss';

export const RenderWrapperError = ({
  touched,
  active,
  error
}: Pick<WrappedFieldMetaProps, 'touched' | 'active' | 'error'>) =>
  getShouldShowError({ touched, active, error }) ? (
    <BaseRenderWrapperError error={error} />
  ) : (
    NO_ELEMENT
  );

export const BaseRenderWrapperError = ({ error }: Pick<WrappedFieldMetaProps, 'error'>) => {
  return <div className={styles.error}>{error}</div>;
};

export const getShouldShowError = ({
  touched,
  active,
  error
}: Pick<WrappedFieldMetaProps, 'touched' | 'active' | 'error'>) => {
  return touched && !active && error;
};
